import { z } from "zod/v4";

import { ShippingRateGroupDtoSchema } from "../../../../dtos/shipping-rate-groups";

export const PluginShippingRateGroupSchema_2024_05_05 =
  ShippingRateGroupDtoSchema;

export type PluginShippingRateGroupType_2024_05_05 = z.infer<
  typeof PluginShippingRateGroupSchema_2024_05_05
>;
